export const Contexts = [
  'global',
  'env',
  'site',
  'product-credit-card',
  'product-insurance',
  'product-unsecured-loan',
  'product-secured-loan',
  'my-page',
  'product',
] as const;
export type Context = (typeof Contexts)[number];
